export default {
  c1: 'Get your MetaID!',
  c2: 'Get the limited MetaID to start the trip of personal digital assets',
  c3: 'Limited MetaID has been prepared for you',
  c4: 'Get It Now',
  c5: 'Congratulations!',
  c6: 'Replace your current MetaID as the new one now',
  c7: 'Go to Replace',
  c8: 'Reminder',
  c9: 'Please replace your current MetaID as the new one in MyLink metaverse within 14 days. Or the ID will automatically expire after 14 days.',
  c10: 'You can also mint the Meta ID to NFT to enjoy more benefit.',
  c11: 'Thank you for your participation!',
  c12: 'You have already got the number',
  c13: 'Check My MetaID',
  c14: 'Reminder',
  c15: 'Please replace your current MetaID as the new one in MyLink metaverse within 14 days. Or the ID will automatically expire after 14 days.',
  c16: 'You can also mint the Meta ID to NFT to enjoy more benefit.',
  c17: 'Sorry!',
  c18: 'Network error occured. Please try later. Thanks',
  c19: 'OK',
  c20: 'Get your MetaID!'
}
